<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT"><i>The Main Characters</i></div>
<div class="fmtx1">LONDON</div>
<div class="fmtx1">Lady Celia Lytton, <i>senior editor at Lyttons publishing house</i></div>
<div class="fmtx1">Lord Arden, <i>her new husband</i></div>
<div class="fmtx1">Giles, <i>twins</i> Venetia <i>and</i> Adele, <i>and</i> Kit, <i>her children</i></div>
<div class="fmtx1">Jay Lytton, <i>their cousin</i></div>
<div class="fmtx1">Boy Warwick, <i>Venetia’s husband</i></div>
<div class="fmtx1">Elspeth Warwick, <i>their daughter</i></div>
<div class="fmtx1">Keir Brown, <i>Elspeth’s boyfriend</i></div>
<div class="fmtx1">Geordie MacColl, <i>Adele’s husband</i></div>
<div class="fmtx1">Clio, <i>their daughter</i></div>
<div class="fmtx1">Noni <i>and</i> Lucas, <i>Adele’s children by Luc Lieberman, deceased</i></div>
<div class="fmtx1">Sebastian Brooke, <i>bestselling author published by Lyttons</i></div>
<div class="fmtx1">Clementine Hartley, <i>another Lyttons author</i></div>
<div> <br/></div><div class="fmtx1">COUNTRY</div>
<div class="fmtx1">Billy Miller, <i>brother of Barty</i></div>
<div class="fmtx1">Joan, <i>his wife, and their sons</i> Joe <i>and</i> Michael</div>
<div> <br/></div><div class="fmtx1">NEW YORK</div>
<div class="fmtx1">Barty Miller, <i>head of Lyttons New York</i></div>
<div class="fmtx1">Jenna Elliott, <i>her daughter by Laurence Elliott,deceased</i></div>
<div class="fmtx1">Cathy Patterson, <i>a schoolfriend of Jenna’s</i></div>
<div class="fmtx1">Charlie Patterson, <i>her father</i></div>
<div class="fmtx1">Jamie Elliott, <i>brother of Laurence and Jenna’s trustee</i></div>
<div class="fmtx1">Kyle Brewer, <i>a literary agent and Jenna’s trustee</i></div>
<div class="fmtx1">Marcus Forrest, <i>editorial director of Lyttons New York</i></div>
<div class="fmtx1">Isabella (Izzie)Brooke, <i>Sebastian’s daughter</i></div>
<div class="fmtx1">Mike Parker and Nick Neill, <i>copywriters, Izzie’s employers</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590208007_oeb_fm1_r1.vue?3f69c4bb